import React from 'react';
import {BrowserRouter,Route,HashRouter} from 'react-router-dom'
// import logo from './logo.svg';
import './App.css';
import Home from './component/home/home'
import Contact from './component/contact us/Contact'
import About from './component/about us/aboutUs'
import Courses from './component/courses/Courses'
import Nav from './component/nav/nav'
import Footer from './component/footer/footer'
import ReactGA from 'react-ga';
import Chatbot from './component/chatbot/chatbot'
import CourseDetails from './component/courses/course_details/Course_details'

function App() {
 
    ReactGA.initialize('UA-159662904-1');
    ReactGA.pageview('/homepage');

  return (
    <HashRouter>
        <Nav/>
        <Chatbot/>
        <Route path={"/"} exact component={Home}/>
        <Route path={"/contact"}  component={Contact}/>
        <Route path={"/courses"} component={Courses}/>
        <Route path={"/about"} component={About}/>
        <Route path={"/courseDetails"} component={CourseDetails} />
        <Footer/>
    </HashRouter>
  );
}

export default App;
